import { PATHS } from '@src/consts'

export const tfaPathNames = [
  PATHS.SIGNIN_TFA_APP,
  PATHS.SIGNIN_TFA_SMS,
  PATHS.SIGNIN_TFA_RECOVERY_CODE,
]
